import { get } from 'lodash';
import { store } from '../../../../src/store';
import { FLAGS_VALUES } from '@Utils/flagsmith-constants';

const getFlagsFromStore = () => {
  const reduxStore = store.getState();
  const flags = get(reduxStore, 'rootReducer.flagsmithReducer.flags', null);
  return flags;
};

const formatKey = (key: string): string => key.toLowerCase().replace(/ /g, '_');
const fallbackFlags = FLAGS_VALUES as Record<string, any>;

export const isFlagEnabled = (key: string): boolean => {
  const formattedKey = formatKey(key);
  const flags = getFlagsFromStore();
  return flags?.[formattedKey]?.enabled ?? fallbackFlags?.[formattedKey]?.isFeatureEnabled ?? false;
};

export const getFlagValue = (key: string) => {
  const formattedKey = formatKey(key);
  const flags = getFlagsFromStore();
  const value = flags?.[formattedKey]?.value ?? fallbackFlags?.[formattedKey]?.data;

  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value ?? null;
};
